
import AppCustomTable from "@/components/common/CustomTable.vue";
import { Contact } from "@/models/base";
import { Reminder } from "@/models/reminder";
import { DossierConfigService, ReminderService } from "@/services";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppReminderSendModalCard from "./ReminderSendModalCard.vue";
import { printDayDiff, printHumanFloat, printLocalDate } from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			humanFloat: printHumanFloat,
			localDate: printLocalDate,
			printDayDiff
		};
	},
	props: {
		contact: {
			type: Object as () => Contact,
			required: true
		},
		reminders: {
			type: Array as () => Reminder[]
		},
		selectedReminders: {
			type: Array as ()=>Reminder[]
		}
	},
	computed: {
		totalCost(): number {
			let total = 0;
			for (let reminder of this.reminders){
				total += reminder.Cost;
			}
			return total;
		},
		totalOpen(): number {
			let total = 0;
			for (let reminder of this.reminders){
				if (!reminder.Sale) continue;
				total += reminder.Sale.TotalOpen;
			}
			return total;
		},
		contactName():string{
			return this.contact.getDisplayName();
		},
		maxCountEnabled(){
			return DossierConfigService.getReminderConfig().IncludeSales || DossierConfigService.getReminderConfig().IncludeSales;
		},
		selectCountText():TranslateResult | string {
			if (!this.maxCountEnabled) {
				return "";
			}
			if (this.reminders.length <= ReminderService.MAX_SALES_PER_LAYOUT) {
				return "";
			}
			return this.$ct("max-reminder-count", {count: this.selectedReminders.length, maxCount: ReminderService.MAX_SALES_PER_LAYOUT});
		},
		maxCountReached():boolean {
			if (!this.maxCountEnabled) {
				return false;
			}
			if (this.selectedReminders.length > ReminderService.MAX_SALES_PER_LAYOUT){
				return true;
			}
			return false;
		},
		nextDisabled():boolean {
			return this.maxCountReached || this.selectedReminders.length == 0;
		},
		allRemindersSelected():boolean{
			return this.reminders.length == this.selectedReminders.length;
		}
	},
	methods: {
		next() {
			this.$emit("next");
		},
		cancel() {
			this.$emit("cancel");
		},
		toggleReminder(reminder:Reminder){
			let index = this.selectedReminders.indexOf(reminder);
			if (index == -1){
				this.selectedReminders.push(reminder);
			}else{
				this.selectedReminders.splice(index, 1);
			}
		},
		isReminderSelected(reminder:Reminder):boolean {
			return this.selectedReminders.indexOf(reminder) != -1;
		},
		setAllRemindersSelected(value:boolean){
			this.selectedReminders.splice(0, this.selectedReminders.length);
			if (value){
				this.selectedReminders.push(...this.reminders);
			}
		}
	},
	components: {
		AppReminderSendModalCard,
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
